function updateCartImages() {
  fetch("/cart.js")
  .then((response) => response.json())
  .then((data) => {
    const items = data.items;
    const cartItems = document.querySelectorAll(".upcart-product-item");
    if(cartItems.length > 0) {
      items.forEach((item) => {
        if (item.properties && item.properties._customization_image) {
          const imageUrl = item.properties._customization_image;
          const cartItem = document.querySelector(`.upcart-product-item[id="${item.key}"]`);

          if (cartItem) {
            const imageContainer = cartItem.querySelector(".upcart-product-image-wrapper img");
            if (imageContainer && imageContainer.src !== imageUrl) {
              imageContainer.src = imageUrl;
            }
            imageContainer.style.opacity = 1;
          }
          
        }
      });
    }
  })
  .catch((error) => {
    console.error("Error fetch cart.js:", error);
  })
}

window.upcartOnCartOpened = () => {
  setTimeout(() => {
    updateCartImages();
  }, 1000)
}
// window.upcartOnCartUpdated = () => {
// }
window.upcartOnCartClosed = function () {
  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer && typeof cartDrawer.close === "function") {
    cartDrawer.close();
  }
};

document.addEventListener('teeinblue-event-component-injected', function() {
  const elementToMove = document.querySelector('.tee-product-price');
  const insertAfterElement = document.querySelector('.product__info-wrapper .product__description');
  if (elementToMove && insertAfterElement) {        
    insertAfterElement.before(elementToMove);
  } 
});

(function() {
  function isIOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
  }

  function isAndroid() {
    return /android/i.test(navigator.userAgent);
  }

  if (isIOS()) {
    document.documentElement.classList.add("is-ios");
  } else if (isAndroid()) {
    document.documentElement.classList.add("is-android");
  }
})();

